export default __webpack_public_path__ + "static/media/postease-1497-new.eeda37c8.png";